import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  BracketReadResponse,
  TournamentDetailResponse,
  TournamentListResponse
} from './tournaments-api.types';

@Injectable({ providedIn: 'root' })
export class TournamentsApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = environment.apiBaseUrl;

  listPublicTournaments(): Observable<TournamentListResponse> {
    return this.http.get<TournamentListResponse>(`${this.apiBaseUrl}/api/tournaments`);
  }

  getPublicTournament(slug: string): Observable<TournamentDetailResponse> {
    return this.http.get<TournamentDetailResponse>(`${this.apiBaseUrl}/api/tournaments/${slug}`);
  }

  getTournamentBracket(slug: string): Observable<BracketReadResponse> {
    return this.http.get<BracketReadResponse>(`${this.apiBaseUrl}/api/tournaments/${slug}/bracket`);
  }
}
